//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/iframe.proto (package dxos.iframe, syntax proto3)
/* eslint-disable */

// TODO(burdon): Rename dxos.xxx.iframe?

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { PublicKey } from "./keys_pb.js";
import { file_dxos_keys } from "./keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/iframe.proto.
 */
export const file_dxos_iframe: GenFile = /*@__PURE__*/
  fileDesc("ChFkeG9zL2lmcmFtZS5wcm90bxILZHhvcy5pZnJhbWUi7gEKEUFwcENvbnRleHRSZXF1ZXN0Ei8KB2Rpc3BsYXkYASABKA4yGS5keG9zLmlmcmFtZS5TaGVsbERpc3BsYXlIAIgBARIsCglzcGFjZV9rZXkYAiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SAGIAQESFQoIc3BhY2VfaWQYBSABKAlIAogBARITCgZ0YXJnZXQYAyABKAlIA4gBARISCgVyZXNldBgEIAEoCEgEiAEBQgoKCF9kaXNwbGF5QgwKCl9zcGFjZV9rZXlCCwoJX3NwYWNlX2lkQgkKB190YXJnZXRCCAoGX3Jlc2V0IusBCg1MYXlvdXRSZXF1ZXN0EigKBmxheW91dBgBIAEoDjIYLmR4b3MuaWZyYW1lLlNoZWxsTGF5b3V0EhwKD2ludml0YXRpb25fY29kZRgCIAEoCUgAiAEBEiwKCXNwYWNlX2tleRgDIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXlIAYgBARIVCghzcGFjZV9pZBgFIAEoCUgCiAEBEhMKBnRhcmdldBgEIAEoCUgDiAEBQhIKEF9pbnZpdGF0aW9uX2NvZGVCDAoKX3NwYWNlX2tleUILCglfc3BhY2VfaWRCCQoHX3RhcmdldCJvChRJbnZpdGF0aW9uVXJsUmVxdWVzdBIWCg5pbnZpdGF0aW9uX3VybBgBIAEoCRIfChdkZXZpY2VfaW52aXRhdGlvbl9wYXJhbRgCIAEoCRIeChZzcGFjZV9pbnZpdGF0aW9uX3BhcmFtGAMgASgJKigKDFNoZWxsRGlzcGxheRIICgROT05FEAASDgoKRlVMTFNDUkVFThABKt4BCgtTaGVsbExheW91dBILCgdERUZBVUxUEAASFwoTSU5JVElBTElaRV9JREVOVElUWRABEicKI0lOSVRJQUxJWkVfSURFTlRJVFlfRlJPTV9JTlZJVEFUSU9OEAISJQohSU5JVElBTElaRV9JREVOVElUWV9GUk9NX1JFQ09WRVJZEAkSDAoISURFTlRJVFkQAxISCg5TSEFSRV9JREVOVElUWRAEEhAKDEVESVRfUFJPRklMRRAFEgkKBVNQQUNFEAYSDgoKSk9JTl9TUEFDRRAHEgoKBlNUQVRVUxAIMlIKCkFwcFNlcnZpY2USRAoKU2V0Q29udGV4dBIeLmR4b3MuaWZyYW1lLkFwcENvbnRleHRSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5Mp4BCgxTaGVsbFNlcnZpY2USPwoJU2V0TGF5b3V0EhouZHhvcy5pZnJhbWUuTGF5b3V0UmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJNChBTZXRJbnZpdGF0aW9uVXJsEiEuZHhvcy5pZnJhbWUuSW52aXRhdGlvblVybFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHliBnByb3RvMw", [file_google_protobuf_empty, file_dxos_keys]);

/**
 * @generated from message dxos.iframe.AppContextRequest
 */
export type AppContextRequest = Message<"dxos.iframe.AppContextRequest"> & {
  /**
   * / The display mode that shell should use.
   *
   * @generated from field: optional dxos.iframe.ShellDisplay display = 1;
   */
  display?: ShellDisplay;

  /**
   * TODO(wittjosiah): Remove.
   * / The key of the joined space.
   *
   * @generated from field: optional dxos.keys.PublicKey space_key = 2;
   */
  spaceKey?: PublicKey;

  /**
   * TODO(wittjosiah): Make the generated type be `SpaceId`.
   * / The id of the joined space.
   *
   * @generated from field: optional string space_id = 5;
   */
  spaceId?: string;

  /**
   * / Target to redirect to after a successful invitation.
   *
   * @generated from field: optional string target = 3;
   */
  target?: string;

  /**
   * / The client has been reset.
   * / Used to Reload the app.
   * / Shell cannot reload the app from within an iframe.
   *
   * @generated from field: optional bool reset = 4;
   */
  reset?: boolean;
};

/**
 * Describes the message dxos.iframe.AppContextRequest.
 * Use `create(AppContextRequestSchema)` to create a new message.
 */
export const AppContextRequestSchema: GenMessage<AppContextRequest> = /*@__PURE__*/
  messageDesc(file_dxos_iframe, 0);

/**
 * @generated from message dxos.iframe.LayoutRequest
 */
export type LayoutRequest = Message<"dxos.iframe.LayoutRequest"> & {
  /**
   * / Determins which panel of the shell is opened.
   *
   * @generated from field: dxos.iframe.ShellLayout layout = 1;
   */
  layout: ShellLayout;

  /**
   * / Invitation code to join a space/identity.
   *
   * @generated from field: optional string invitation_code = 2;
   */
  invitationCode?: string;

  /**
   * TODO(wittjosiah): Remove.
   * / Key of the space to share.
   *
   * @generated from field: optional dxos.keys.PublicKey space_key = 3;
   */
  spaceKey?: PublicKey;

  /**
   * / Id of the space to share.
   *
   * @generated from field: optional string space_id = 5;
   */
  spaceId?: string;

  /**
   * / Target to include in an invitation for redirecting after a successful invitation.
   *
   * @generated from field: optional string target = 4;
   */
  target?: string;
};

/**
 * Describes the message dxos.iframe.LayoutRequest.
 * Use `create(LayoutRequestSchema)` to create a new message.
 */
export const LayoutRequestSchema: GenMessage<LayoutRequest> = /*@__PURE__*/
  messageDesc(file_dxos_iframe, 1);

/**
 * @generated from message dxos.iframe.InvitationUrlRequest
 */
export type InvitationUrlRequest = Message<"dxos.iframe.InvitationUrlRequest"> & {
  /**
   * / Base URL for invitations.
   *
   * @generated from field: string invitation_url = 1;
   */
  invitationUrl: string;

  /**
   * / Query parameter for device invitations.
   *
   * @generated from field: string device_invitation_param = 2;
   */
  deviceInvitationParam: string;

  /**
   * / Query parameter for space invitations.
   *
   * @generated from field: string space_invitation_param = 3;
   */
  spaceInvitationParam: string;
};

/**
 * Describes the message dxos.iframe.InvitationUrlRequest.
 * Use `create(InvitationUrlRequestSchema)` to create a new message.
 */
export const InvitationUrlRequestSchema: GenMessage<InvitationUrlRequest> = /*@__PURE__*/
  messageDesc(file_dxos_iframe, 2);

/**
 * @generated from enum dxos.iframe.ShellDisplay
 */
export enum ShellDisplay {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: FULLSCREEN = 1;
   */
  FULLSCREEN = 1,
}

/**
 * Describes the enum dxos.iframe.ShellDisplay.
 */
export const ShellDisplaySchema: GenEnum<ShellDisplay> = /*@__PURE__*/
  enumDesc(file_dxos_iframe, 0);

/**
 * @generated from enum dxos.iframe.ShellLayout
 */
export enum ShellLayout {
  /**
   * @generated from enum value: DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: INITIALIZE_IDENTITY = 1;
   */
  INITIALIZE_IDENTITY = 1,

  /**
   * @generated from enum value: INITIALIZE_IDENTITY_FROM_INVITATION = 2;
   */
  INITIALIZE_IDENTITY_FROM_INVITATION = 2,

  /**
   * @generated from enum value: INITIALIZE_IDENTITY_FROM_RECOVERY = 9;
   */
  INITIALIZE_IDENTITY_FROM_RECOVERY = 9,

  /**
   * @generated from enum value: IDENTITY = 3;
   */
  IDENTITY = 3,

  /**
   * @generated from enum value: SHARE_IDENTITY = 4;
   */
  SHARE_IDENTITY = 4,

  /**
   * @generated from enum value: EDIT_PROFILE = 5;
   */
  EDIT_PROFILE = 5,

  /**
   * @generated from enum value: SPACE = 6;
   */
  SPACE = 6,

  /**
   * @generated from enum value: JOIN_SPACE = 7;
   */
  JOIN_SPACE = 7,

  /**
   * @generated from enum value: STATUS = 8;
   */
  STATUS = 8,
}

/**
 * Describes the enum dxos.iframe.ShellLayout.
 */
export const ShellLayoutSchema: GenEnum<ShellLayout> = /*@__PURE__*/
  enumDesc(file_dxos_iframe, 1);

/**
 * / App RPCs for the shell.
 *
 * @generated from service dxos.iframe.AppService
 */
export const AppService: GenService<{
  /**
   * @generated from rpc dxos.iframe.AppService.SetContext
   */
  setContext: {
    methodKind: "unary";
    input: typeof AppContextRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_iframe, 0);

/**
 * / Shell UI RPCs.
 *
 * @generated from service dxos.iframe.ShellService
 */
export const ShellService: GenService<{
  /**
   * @generated from rpc dxos.iframe.ShellService.SetLayout
   */
  setLayout: {
    methodKind: "unary";
    input: typeof LayoutRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc dxos.iframe.ShellService.SetInvitationUrl
   */
  setInvitationUrl: {
    methodKind: "unary";
    input: typeof InvitationUrlRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_iframe, 1);

